import { useEffect } from 'react'
import type { NavigateFunction } from 'react-router'
import type { UserProfile } from '../../../api/swagger'

/**
 * Redirects to /account/profile when the user cannot edit the invoice
 * signature, otherwise triggers the fetchInvoiceSignature.
 */
export const useInvoiceProfileAccessEffect = ({
  canEditInvoiceSignature,
  userInformation,
  fetchInvoiceSignature,
  navigate,
}: {
  canEditInvoiceSignature: boolean
  userInformation: UserProfile | undefined
  fetchInvoiceSignature: () => void
  navigate: NavigateFunction
}): void => {
  useEffect(() => {
    if (!canEditInvoiceSignature) {
      navigate(
        {
          pathname: '/account/profile',
        },
        {
          replace: true,
        }
      )
      return
    }
    /**
     * Wait for the value of userContext to call fetchInvoiceSignature
     * since we need it if no invoiceSignature record is found.
     */
    if (userInformation) fetchInvoiceSignature()
  }, [
    canEditInvoiceSignature,
    fetchInvoiceSignature,
    navigate,
    userInformation,
  ])
}
